import { createContext, useContext } from "react";
import type { TourDef } from "./tours";

export interface Guides {
  /** Guided tours are switched on (Features__GuidedTours). */
  enabled: boolean;
  /** Every tour this person may see, welcome first then newest release first. */
  available: readonly TourDef[];
  /** Starts a tour now (replay). Returns why it cannot start here, or null when it started. */
  replay(tourId: string): string | null;
}

const OFF: Guides = { enabled: false, available: [], replay: () => null };

export const GuidesContext = createContext<Guides>(OFF);

export function useGuides(): Guides {
  return useContext(GuidesContext);
}
